import type { UIMessageChunk } from 'ai';

export const BLOCKED_NOTICE = "Clarity couldn't answer this message. Try rephrasing it.";
export const FAILED_NOTICE = "Something went wrong and Clarity couldn't answer. Please try again.";

const SAFETY_PROCESSOR_IDS = new Set(['moderation', 'prompt-injection-detector']);

export const isSafetyBlock = (processorId: unknown) => typeof processorId === 'string' && SAFETY_PROCESSOR_IDS.has(processorId);

export function tripwireOf(chunk: UIMessageChunk): { processorId?: unknown; reason?: unknown } | undefined {
	if (chunk.type !== 'data-tripwire') return undefined;
	const { data } = chunk;
	if (typeof data !== 'object' || data === null) return {};
	return {
		processorId: 'processorId' in data ? data.processorId : undefined,
		reason: 'reason' in data ? data.reason : undefined,
	};
}

export function streamFailureNotice(chunk: UIMessageChunk): string | undefined {
	if (chunk.type === 'error') return FAILED_NOTICE;
	const tripwire = tripwireOf(chunk);
	if (!tripwire) return undefined;
	return isSafetyBlock(tripwire.processorId) ? BLOCKED_NOTICE : FAILED_NOTICE;
}
